import React from "react"
import PropTypes from "prop-types"

import css from "./TextualButton.scss"

function TextualButton(props) {
    const { isDisabled, onClick, iconUrl, label, variantSmall, rightIconUrl } = props
    const className = `${css.button} ${variantSmall ? "smallMedium" : "bodySemiBold"} ${
        isDisabled ? css.disabled : ""
    }`
    return (
        <button className={className} onClick={onClick} disabled={isDisabled}>
            {iconUrl ? <img src={iconUrl} className={css.imageSpan} alt="Icon" title="textButton" /> : null}
            {label}
            {rightIconUrl ? (
                <img src={rightIconUrl} className={css.rightImageSpan} alt="Icon" title="textButton" />
            ) : null}
        </button>
    )
}

TextualButton.propTypes = {
    variantSmall: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    iconUrl: PropTypes.string,
    label: PropTypes.string.isRequired,
    rightIconUrl: PropTypes.string,
}

export default TextualButton
